import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ProductOccupancy from './ProductOccupancy';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import compose from 'recompose/compose';
import { fetchProduct } from 'store/actions/products/fetchProducts';

class ProductOccupancyContainer extends Component {
    render() {
        const {
            data,
            form,
            history,
            id,
            location,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        if (!data) {
            return null;
        }
        return <ProductOccupancy
            form={ form }
            history={ history }
            id={ id }
            location={ location }
            product={ data }
            resource={ resource }
        />;
    }
}

ProductOccupancyContainer.propTypes = {
    data: PropTypes.object,
    form: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.string,
    location: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const enhance = compose(
    fetchResourceById({
        action: fetchProduct,
        resource: 'products',
    }),
);

export default enhance(ProductOccupancyContainer);


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/ProductOccupancyContainer.js